import { faFileLines } from '@fortawesome/free-regular-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled: boolean
}

const DocumentRequestsButton: FC<Props> = ({ onClick, disabled }) => (
  <ActionButton
    disabled={disabled}
    label="Document Requests"
    icon={faFileLines}
    onClick={onClick}
  />
)

export default DocumentRequestsButton
